// First-party visitor + session identity for the Founder Funnel (owned analytics).
function uuid() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch {}
  return `${Date.now().toString(36)}-${Math.random().toString(16).slice(2)}`;
}

// Persistent visitor id (across sessions) — used for new-vs-returning.
export function getVisitorId() {
  try {
    let id = localStorage.getItem("cu_vid");
    if (!id) {
      id = uuid();
      localStorage.setItem("cu_vid", id);
    }
    return id;
  } catch {
    return "anon";
  }
}

// Per-tab/browser-session id.
export function getSessionId() {
  try {
    let sid = sessionStorage.getItem("cu_sid");
    if (!sid) {
      sid = uuid();
      sessionStorage.setItem("cu_sid", sid);
    }
    return sid;
  } catch {
    return "anon-session";
  }
}

// Returning = a prior session was recorded for this visitor before the current one.
export function isReturning() {
  try {
    return localStorage.getItem("cu_seen") === "1" && !sessionStorage.getItem("cu_first");
  } catch {
    return false;
  }
}

// Call once on app boot to establish session + returning state.
export function initSession() {
  try {
    getVisitorId();
    if (!sessionStorage.getItem("cu_sid")) {
      // brand-new session for this tab
      if (localStorage.getItem("cu_seen") !== "1") {
        sessionStorage.setItem("cu_first", "1"); // first-ever session
      }
      getSessionId();
      localStorage.setItem("cu_seen", "1");
    }
  } catch {}
}
